import { errorToString, ErrorToStringOptions } from 'helpers/error-helpers';
import { toast, ToastOptions } from 'react-toastify';
import { Toast } from './Toast';

type ShowToastProps = {
  content: {
    title?: string;
    description?: string | React.ReactNode;
  };
  options?: ToastOptions;
};

export const showErrorToast = (
  error: unknown | string,
  errorParserOptions?: ErrorToStringOptions,
  options?: ToastOptions,
) =>
  toast.error(
    (context) => (
      <Toast
        description={
          typeof error === 'string'
            ? error
            : errorToString(error, errorParserOptions)
        }
        context={context}
      />
    ),
    options,
  );

export const showWarningToast = (props: ShowToastProps) =>
  toast.warning(
    (context) => <Toast {...props.content} context={context} />,
    props.options,
  );

export const showSuccessToast = (props: ShowToastProps) =>
  toast.success(
    (context) => <Toast {...props.content} context={context} />,
    props.options,
  );
